import React, {Component} from 'react';
import QuestionNotifyScreen from '../../screens/questions/QuestionNotifyScreen';

export default class QuestionNotifyContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            time: 5
        };

        this.intervalID = setInterval(() => {
            this.setState({time: this.state.time - 1});
            if (this.state.time === 0) this.props.handleCloseQuestionNotify();
        }, 1000);
    };

    componentDidMount() {
        this.prepareData();
    };

    componentWillUnmount() {
        clearInterval(this.intervalID);
    };

    prepareData = () => {
        let educationQuestionsCounter = {
            counterEducaionQuestions:[],
            total:0
        };
        this.props.educations.forEach(el => {
            let educationQuestionCounter = {
                title: el.title,
                count: 0
            }
             el.listStep.forEach(step => {
            if(step.name === "question")
            {
               educationQuestionCounter.count +=1;
               educationQuestionsCounter.total +=1;
            }            
             })
             educationQuestionsCounter.counterEducaionQuestions[el.type] = educationQuestionCounter;
        });   
        this.setState(educationQuestionsCounter);
    };

    render() {
        return <QuestionNotifyScreen {...this.state} t={this.props.t} handleCloseQuestionNotify={this.props.handleCloseQuestionNotify} />
    };
};